// ======================================================================
// File Name       : DialogMessageUsageSettingSufCustomize
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Modal } from 'react-bootstrap';

class DialogMessageUsageSettingSufCustomize extends React.Component {
  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        onHide={this.props.onCancel && this.props.onCancel}
        size={this.props.mdSize}
        animation={this.props.animation}
        style={style}
        id="dialogMessageUsageSettingSufCustomize"
      >
        <Modal.Body className={!this.props.leftContent && 'text-center'}>
          <div>
            <div className="form-group">
              <div className="margin-left-10 col-sm-12">
                <div className="col-sm-12 margin-bottom-10">
                  <p>サービス利用ユーザー画面をカスタマイズする場合、</p>
                </div>
                <div className="col-sm-12 margin-bottom-10">
                  <p>サービス利用ユーザー画面の保守対象外となるため、</p>
                </div>
                <div className="col-sm-12 margin-bottom-10">
                  <p>ご注意ください。</p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="text-center">
          <Button className=" margin-left-10 btn-96" onClick={this.props.onOK}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

DialogMessageUsageSettingSufCustomize.defaultProps = { animation: true };
export default DialogMessageUsageSettingSufCustomize;
